import { CommonModule, DecimalPipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ApiserviceService } from '../../apiservice.service';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResponsiveUIService } from '../../../services/responsive-ui.service';
import { debounceTime, Subscribable, Subscription } from 'rxjs';

import { HelpSupportComponent } from "../../../shared/components/help-support/help-support.component";
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { NavigationEnd, Router, RouterModule,Event as NavigationEvent } from '@angular/router';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { CartService } from '../../../shared/services/cart.service';
import { SafePipe } from '../../../shared/pipes/safe.pipe';
import { SafehtmlPipe } from '../../../shared/pipes/safehtml.pipe';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';
import { SchemaService } from '../../../shared/services/schema.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { HttpService } from '../../../shared/services/http.service';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { SignInService } from '../../../shared/services/sign-in.service';
import { environment } from '../../../environments/environment';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { InbtHomepageService } from '../../../shared/services/inbt-homepage.service';
import { CartDetailsService } from '../../../shared/services/cart-details.service';
interface ImageOptimizationOptions {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'webp' | 'jpeg' | 'png';
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, CarouselModule,RouterModule ,SafePipe, TruncatePipe, SafehtmlPipe, HttpClientModule, HelpSupportComponent,CarousalPageComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnDestroy, AfterViewInit {
  environment: any = environment;
  homePageData: any;
  smallWebBannerList: any = [];
  smallMobileBannerList: any = [];
  productCarousalData!: any[];
    deviceStatus:any;
  responsiveSub:Subscription=new Subscription();

  autoplay: boolean=true;
  sub:Subscription=new Subscription()
  countSectionImg: any = [
    environment.blobUrl+"/assets/images/inbt-homepage/countries.svg",
    environment.blobUrl+"/assets/images/inbt-homepage/customer.svg",
    environment.blobUrl+"/assets/images/inbt-homepage/Distributor.svg",
    environment.blobUrl+"/assets/images/inbt-homepage/Dealer.svg"
  ]
  cartObject: any = [];
  isCartModified: boolean = false;
  imgLoaded: boolean = false;
  actualSchemaValue!: any;
  script: any;

  constructor(public utils: UtilsService,    private responsivSrv:ResponsiveUIService,

 @Inject(PLATFORM_ID) private platformId: Object,
    public analyticsService: AnalyticsService, private homeSvc: InbtHomepageService, private metaSvc: MetaMgmtService, private router: Router, public CartService: CartService, public service: CartDetailsService, private _dataLayerService: DataLayerService,
    @Inject(DOCUMENT) private _document: Document,
    private _renderer2: Renderer2,
    private schemaService: SchemaService,) {
       this.responsiveSub = this.responsivSrv.getDeviceStatus().subscribe((res:any) => {
      if(res){
        this.deviceStatus = res
      }else{}
    })
    // this.utils.showLoading();
    this.homeSvc.getHomePageData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        if (res.success) {
          this.homePageData = res;
          this.processData();
        }
        else {
          this.utils.openSnackBar('Something went wrong', 'error-toster');
          this.utils.hideLoading();
        }
      }
    })
    if (!this.isSchemaAdded()) {
      this.callSchema();
    }
  }

  ngOnInit(): void {
   this.sub.add( this.CartService.cartData$.subscribe(
      (data: any) => {
        this.utils.hideLoading()
        this.cartObject = data ? data : []
      }))
    // this.getCartItems()
    
  }
   getOptimizedImageUrl(url: string, options: ImageOptimizationOptions = {}): string {
    // Check if URL is from Azure CDN
    if (!url.includes('azureedge.net')) return url;
  
    const params = new URLSearchParams();
    
    // Add width for different devices
    if (options.width) {
      params.append('w', options.width.toString());
    }
    
    // Add height if specified
    if (options.height) {
      params.append('h', options.height.toString());
    }
    
    // Set quality (80% is good balance)
    params.append('q', (options.quality || 80).toString());
    
    // Convert to WebP if supported
    params.append('format', options.format || 'webp');
  
    return `${url}?${params.toString()}`;
  }
  private isSchemaAdded(): boolean {
    // Check if schema is present in the document
    const existingSchema = this._document.querySelector('script[type="application/ld+json"]');
    return !!existingSchema; // Returns true if schema is present, false otherwise
  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.gethomeSchema();
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = JSON.stringify(this.actualSchemaValue);
    this.script.defer = true;
    this._renderer2.appendChild(this._document.body, this.script);
  }
  ngAfterViewInit() {
    if (this.homePageData?.mainBannerResponse && this.homePageData?.mainBannerResponse.length > 1) {
      this.utils.customOptionsForBanner.loop = true;
    }
    this.imgLoaded = true;
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.updateAutoplay();
  }


  handleSlideChange(event: any, type: string) {
    let currentSlideData: any;
    let slideList: any[];
    if (this.autoplay) {
      currentSlideData = this.homePageData?.mainBannerResponse[event.startPosition];
      slideList = this.homePageData?.mainBannerResponse;
      currentSlideData.creativeSlot = event.startPosition + 1;
      this.triggerPromotionEventsIfListExists([currentSlideData]);
    }
  }

  updateAutoplay() {
    const isBannerVisible = this.utils.isElementVisible('caraousel-scroll');
    if (!isBannerVisible) {
      this.autoplay = false;
    } else {
      this.autoplay = true;
    }
  }

  triggerPromotionEventsIfListExists(bannerList: any) {
    if (bannerList && bannerList.length > 0) {
      this._dataLayerService.triggerPromotionEvents(bannerList, 'view_promotion');
    }
  }

  processData() {
    if (this.homePageData && this.homePageData.smallBannerResponse && this.homePageData.smallBannerResponse.isSmallBanner) {
      let bannerData = this.homePageData.smallBannerResponse;
      this.smallMobileBannerList = [];
      this.smallWebBannerList = [];
      let mobileBanner = {
        image: bannerData.mobileImageFile,
        link: bannerData.ctaLink,
        altTag: bannerData.altTag,
        guidId: bannerData.guidId,
        isSmallBanner: bannerData.isSmallBanner,
        filename: bannerData.mobileImageFileName
      }
      let webBanner = {
        image: bannerData.webImageFile,
        link: bannerData.ctaLink,
        altTag: bannerData.altTag,
        guidId: bannerData.guidId,
        isSmallBanner: bannerData.isSmallBanner,
        filename: bannerData.webImageFileName
      }
      this.smallWebBannerList.push(webBanner);
      this.smallMobileBannerList.push(mobileBanner);
      if (this.smallWebBannerList && this.smallWebBannerList.length > 1) {
        this.utils.customOptionsForSmallBanner.loop = true;
      }
    }
    if (this.homePageData && this.homePageData.brandLandingPageOurProductsResponse && this.homePageData.brandLandingPageOurProductsResponse.length) {
      this.productCarousalData = [];
      this.homePageData.brandLandingPageOurProductsResponse.forEach((element: any) => {
        let obj = {
          image: element.productImage,
          description: element.productName,
          price: element.productPrice ? element.productPrice : '0',
          altTag: element.productImageAltTag ? element.productImageAltTag : 'product',
          productGuid: element.productGuidId
        }
        this.productCarousalData.push(obj);
      });
    }
    this.metaSvc.updateMetaTags(this.homePageData.metaInfoResponse);
    // this.utils.hideLoading();
    this.utils.showHeaderFooter.next(true);
  }

  categoryCLickHandler(categoryData: any) {
    let url = ''
    if (this.utils.checkValidityOfGuid(categoryData.landingPageGuid)) {
      let catTitle = this.utils.createNameForUrl(categoryData.categoryName);
      if (categoryData.landingType && categoryData.landingType.toLowerCase() == 'solarcategorylanding') {
        url = `/category/solar/${catTitle}`
      }
      else {
        url = `/category/energy-storage/${catTitle}`
      }
    }
    return url;
  }

  triggerBannerClick(bannerData: any) {
    const data = {
      eventName: "Banner Clicked",
      eventData: {
        'Banner Name': bannerData.altTag,
      }
    };
    this.analyticsService.trackData(data);
    this._dataLayerService.triggerPromotionEvents(bannerData, 'select_promotion');
  }

  triggerCategoryClicked(catTitle: string) {
    const data = {
      eventName: "Category Clicked",
      eventData: {
        'Category Name': catTitle
      }
    };
    this.analyticsService.trackData(data);
  }

  onProductClick(data: any) {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.setItem('source', 'Brand');
  }}
  getCartItems() {
    if (isPlatformBrowser(this.platformId)) {
    if (this.utils.getToken()) {
   this.sub.add(   this.CartService.getItems().subscribe({
        next: (response: any) => {
          this.utils.hideLoading()
          if (response.success) {
            if (this.cartObject && this.cartObject.length) {
              this.CartService.processCartItems(this.cartObject, response, (updateCart: any) => {
                if (updateCart) {
                 this.sub.add( this.service.checkout().subscribe((data: any) => {
                  }))
                }
              }, (_emptyCart: any) => {
                this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                this.CartService.clearInfo();
               this.sub.add( this.service.checkout().subscribe((data: any) => {
                }))
              },
                false, this.utils.isRecentLogin ? true : false, (_pincodeChanged: any) => {
                  this.service.pinCodeChange();
                });
            }
            else {
              if (response.cartDetailList && response.cartDetailList.length) {
                this.utils.setUserPicode(response.cartDetailList[0].pincode);
                this.CartService.setInfo(response.cartDetailList, false);
              }
            }
            localStorage.removeItem('startTime')
            // this.utils.hideLoading();
          }
          else {
            if (response && (response.statusCode != "204" && response.message != 'Record not found')) {
              this.CartService.clearInfo()
              this.utils.openSnackBar(response.message, 'error-toster');
            }
            else {
              if (this.cartObject && this.cartObject.length) {
                this.CartService.processCartItems(this.cartObject, response, (updateCart: any) => {
                  if (updateCart) {
                   this.sub.add( this.service.checkout().subscribe((data: any) => {
                    }))
                  }
                }, (_emptyCart: any) => {
                  this.utils.openSnackBar('Product(s) added to cart have gone out of stock.', 'error-toster');
                  this.CartService.clearInfo();
                  this.sub.add(this.service.checkout().subscribe((data: any) => {
                  }))
                },
                  false, this.utils.isRecentLogin ? true : false);
              }
            }
            // this.utils.hideLoading();
          }
        }
      }))
    }
  }
}
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
